export default __webpack_public_path__ + "static/media/sell-01.b795e739.png";